var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareMessengerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FC686F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 20C24.4775 20 20 24.145 20 29.2587C20 32.1725 21.4538 34.7712 23.7262 36.4688V40L27.1312 38.1313C28.04 38.3825 29.0025 38.5187 30 38.5187C35.5225 38.5187 40 34.3737 40 29.26C40 24.1462 35.5225 20 30 20ZM30.9937 32.4688L28.4475 29.7525L23.4787 32.4688L28.945 26.6663L31.5538 29.3825L36.46 26.6663L30.9937 32.4688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMessengerIcon);
export default __webpack_public_path__ + "static/media/share-messenger-icon.c287a8165be8600ebe9f7a66045f1710.svg";
export { ForwardRef as ReactComponent };